import VirtualDropdown from "common/components/VirtualDropdown"
import { INITIAL_QUERY_PARAMETERS } from "features/Crear/components/LibradoCard/constants"
import { getListadoDepartamentos } from "features/User/pages/RoleManagement/services/roles"
import { setIsDepartamentosFilterActive } from "features/User/redux/slices/userSlice"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { useTranslation } from "react-i18next"
import {
  DEFAULT_AUTOVALIDACION,
  mapDepartamentosSelectToEtapas,
} from "../../constants"
import EtapasElement from "../EtapaItem"
import "./style.scss"

const EtapasList = ({
  setLocalValue,
  departamentosList,
  onHandleScroll,
  departamentosTotalCount,
  localValue,
  etapasSelected,
  handleEtapasSelected,
  handleRemove,
  handleCount,
  handleBlur,
  setEtapasSelected,
  setFieldValue,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const departamentos = [DEFAULT_AUTOVALIDACION, ...departamentosList]

  const reorder = (
    list: $TSMigrationFixMe,
    startIndex: $TSMigrationFixMe,
    endIndex: $TSMigrationFixMe
  ) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  const onDragEnd = (result: $TSMigrationFixMe) => {
    if (!result.destination) {
      return
    }

    const items = reorder(
      etapasSelected,
      result.source.index,
      result.destination.index
    )
    const orderItems = items.map((item, i) => {
      // @ts-expect-error TS(2698): Spread types may only be created from object types...
      return { ...item, orden: i }
    })

    setEtapasSelected(orderItems)
    setFieldValue("etapas", mapDepartamentosSelectToEtapas(orderItems))
  }
  return (
    <>
      <div className='mb-3 p-fluid'>
        <label htmlFor='tipoDocumento'>
          {t("flujoAprobaciones.modalFlujo.labelStages")}
        </label>
        <VirtualDropdown
          filter
          options={departamentos || []}
          onChange={(e: $TSMigrationFixMe) => {
            setLocalValue(e.value)
            handleEtapasSelected(e)
          }}
          placeholder={`${t("flujoAprobaciones.modalFlujo.placeholderStages")}`}
          emptyFilterMessage={`${t(
            "flujoAprobaciones.modalFlujo.emptyFilterMsg"
          )}`}
          emptyMessage={`${t("flujoAprobaciones.modalFlujo.emptyFilterMsg")}`}
          id='select-id'
          handleOnScroll={onHandleScroll}
          startPage={20}
          fetchCallback={getListadoDepartamentos}
          initialQueryParameters={INITIAL_QUERY_PARAMETERS}
          userKey='librado'
          totalCount={departamentosTotalCount}
          setIsSelectFilterActive={setIsDepartamentosFilterActive}
          value={localValue}
          onBlur={handleBlur}
          panelClassName='!tw-z-[2302]'
        />
      </div>
      <div className='mb-3 p-fluid board__container'>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId='droppable'>
            {(provided: $TSMigrationFixMe) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {etapasSelected.map(
                  (etapa: $TSMigrationFixMe, index: $TSMigrationFixMe) => (
                    <Draggable
                      key={etapa.departamentoId}
                      draggableId={etapa.departamentoId}
                      index={index}
                    >
                      {(provided: $TSMigrationFixMe) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <EtapasElement
                            etapa={etapa}
                            handleRemove={handleRemove}
                            handleCount={handleCount}
                            orden={index + 1}
                          />
                        </div>
                      )}
                    </Draggable>
                  )
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </>
  )
}

export default EtapasList
